module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-minus-acc5fa62.svg";